import { lazy } from 'react';

export const MainPage = lazy(() => import('./main/MainPage'));
export const LoginPage = lazy(() => import('./login/LoginPage'));
export const PlayPage = lazy(() => import('./play/PlayPage'));
export const PlayListPage = lazy(() => import('./play/playList/PlayListPage'));
export const CustomPage = lazy(() => import('./custom/CustomPage'));
export const ChatBotPage = lazy(() => import('./custom/chatbot/ChatBotPage'));
export const PlayerPage = lazy(() => import('./player/PlayerPage'));
export const PlayerV2Page = lazy(() => import('./playerV2/PlayerPage'));
export const SchoolPage = lazy(() => import('./school/School'));
export const ManagePage = lazy(() => import('./manage/Manage'));
export const StoragePage = lazy(() => import('./storage/StoragePage'));
export const NoticePage = lazy(() => import('./notice/NoticePage'));
export const MaintenancePage = lazy(() =>
	import('./maintenancePage/MaintenanacePage'),
);
export const CalendarPage = lazy(() => import('./calendar/CalendarPage'));
export const AiRobotPage = lazy(() => import('./airobot/AiRobotPage'));
